<template>
  <template v-if="blok.caption || blok.asset?.title">
    <figure>
      <component
        :is="blok.youtube_link ? 'YoutubePlayer' : 'MediaPlayer'"
        :blok="blok"
        :loading="loading"
        :fetch-priority="fetchPriority"
        :play-disabled="playDisabled"
        :stop-video="stopVideo"
        :size-hint="sizeHint"
        :size-hint-mobile="sizeHintMobile"
        :max-width="maxWidth"
        :quality="quality"
      />
      <figcaption>{{ blok.caption || blok.asset?.title }}</figcaption>
    </figure>
  </template>

  <template v-else>
    <component
      :is="blok.youtube_link ? 'YoutubePlayer' : 'MediaPlayer'"
      :blok="blok"
      :loading="loading"
      :fetch-priority="fetchPriority"
      :play-disabled="playDisabled"
      :stop-video="stopVideo"
      :size-hint="sizeHint"
      :size-hint-mobile="sizeHintMobile"
      :max-width="maxWidth"
      :quality="quality"
    />
  </template>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  loading: {
    type: String,
    required: false,
    default: undefined,
  },
  fetchPriority: {
    type: String,
    required: false,
    default: undefined,
  },
  playDisabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  stopVideo: {
    type: Boolean,
    required: false,
    default: false,
  },
  sizeHint: {
    type: Number,
    required: false,
    default: 100,
  },
  sizeHintMobile: {
    type: Number,
    required: false,
    default: undefined,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: undefined,
  },
  quality: {
    type: Number,
    required: false,
    default: undefined,
  },
});
</script>

<style lang="scss">
figure .youtube-player {
  margin-bottom: 0.375rem;
}
</style>
